import { render, staticRenderFns } from "./goodsType.vue?vue&type=template&id=fa4951aa&scoped=true&"
import script from "./goodsType.vue?vue&type=script&lang=js&"
export * from "./goodsType.vue?vue&type=script&lang=js&"
import style0 from "./goodsType.vue?vue&type=style&index=0&id=fa4951aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4951aa",
  null
  
)

export default component.exports